import { Flex, Select } from "@chakra-ui/react";

const Dropdown = ({
  margin,
  width,
  height,
  placeHolder,
  name,
  options,
  optionKey,
  optionDisplay,
  state,
  handleChange,
  optionDisplayAdd,
  optionDataAdd,
  required,
}) => {
  return (
    <Flex h={height} w={width} m="0">
      <Select
        name={name}
        onChange={handleChange}
        placeholder={placeHolder}
        h={height}
        borderRadius="0"
        value={state[name] != null && state[name] !== "" ? String(state[name]) : ""}
        isRequired={required}
        mt={margin}
      >
        {options.map((option) => (
          <option
            value={String(option[optionKey])}
            key={option[optionKey]}
            data-selected={option[optionDataAdd]}
          >
            {option[optionDisplay]} {option[optionDisplayAdd]}
          </option>
        ))}
      </Select>
    </Flex>
  );
};

export default Dropdown;
